import React, { useState, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import serviceProvider from '../../services/axios'
import { ResulttourView } from "./resulttour-view";

export const ResulttourController = (props) => {
  const user = JSON.parse(localStorage.getItem("userData"));
 useEffect(() => {
		props.handleExpandFal();
	}, []);
	
	
	const login = localStorage.getItem("isLoggedIn");
	if (!login) {
		return <Redirect to="/sign-in" />;
	}
	
  return <ResulttourView {...props} />;
};
